import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';

// TODO: Set your Google Client ID here or load from env
const GOOGLE_CLIENT_ID =
  '467041705561-mjpsd8u4alc4l9vvc24akk6bs5ie72o2.apps.googleusercontent.com';

export default function LoginPage() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    // Load Google Identity Services script
    if (!window.google) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      script.onload = renderButton;
    } else {
      renderButton();
    }
    function renderButton() {
      if (
        window.google &&
        window.google.accounts &&
        document.getElementById('g_id_signin')
      ) {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
        });
        const signinElem = document.getElementById('g_id_signin');
        if (!signinElem) return;
        window.google.accounts.id.renderButton(signinElem, {
          theme: 'outline',
          size: 'large',
        });
      }
    }
    // eslint-disable-next-line
  }, []);

  function handleCredentialResponse(response: any) {
    // response.credential is a JWT (Google ID token)
    const jwt = response.credential;
    // Decode JWT to get user info (basic, not verified)
    const base64Url = jwt.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const user = JSON.parse(window.atob(base64));
    login(user, jwt);
  }

  return (
    <div>
      <h1>QR Hub</h1>
      {user ? (
        <div>
          <p>
            Signed in as {user.name} ({user.email})
          </p>
          <button onClick={logout}>Log out</button>
        </div>
      ) : (
        <div id="g_id_signin" />
      )}
    </div>
  );
}
